import {createSlice, PayloadAction} from "@reduxjs/toolkit";

type State = {
  id: number | string;
  idXetNghiem: number | string;
  id2: number | string;
  dataPay: any;
  callApi: boolean;
  dataRefunds: any;
  optionModal: number | string;
  valueInput: number | string;
  IdKQXN: number | string;
  money: string | number;
  idPrintXn: string | number;
  maBenhNhan: string | number;
  nguoiDuyetXN: string | number;
  listIdCommon: any;
  valueMienGiam: any;
  thoiGian: any;
  thoiGianLayMau: any;
  typePhieu: any;
  isInPayTab: boolean;
  tableThanhToan: any;
};

const initialState: State = {
  id: null,
  idXetNghiem: null,
  id2: null,
  dataPay: null,
  callApi: true,
  dataRefunds: null,
  optionModal: null,
  valueInput: null,
  IdKQXN: null,
  money: null,
  idPrintXn: null,
  maBenhNhan: null,
  nguoiDuyetXN: null,
  listIdCommon: null,
  valueMienGiam: null,
  thoiGian: null,
  thoiGianLayMau: null,
  typePhieu: null,
  isInPayTab: false,
  tableThanhToan: null,
};

export const reduxCommonSlice = createSlice({
  name: "reduxCommon",
  initialState: initialState,
  reducers: {
    setId: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        id: actions.payload,
      };
    },
    setIdXetNghiem: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idXetNghiem: actions.payload,
      };
    },
    setIdSecond: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        id2: actions.payload,
      };
    },
    setDataPay: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        dataPay: actions.payload,
      };
    },
    setCallApi: (state = initialState) => {
      return {
        ...state,
        callApi: !state.callApi,
      };
    },
    setDataRefunds: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        dataRefunds: actions.payload,
      };
    },
    setOptionModal: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        optionModal: actions.payload,
      };
    },
    setValueInput: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        valueInput: actions.payload,
      };
    },
    setIdKQXN: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        IdKQXN: actions.payload,
      };
    },
    setTotalMoney: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        money: actions.payload,
      };
    },
    setIdPrintXN: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idPrintXn: actions.payload,
      };
    },
    setMaBenhNhan: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        maBenhNhan: actions.payload,
      };
    },
    setNguoiDuyetXN: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        nguoiDuyetXN: actions.payload,
      };
    },
    setListIdCommon: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listIdCommon: actions.payload,
      };
    },
    setValueMG: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        valueMienGiam: actions.payload,
      };
    },
    setTGChiDinh: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        thoiGian: actions.payload,
      };
    },
    setTGLayMau: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        thoiGianLayMau: actions.payload,
      };
    },
    setTypePhieu: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        typePhieu: actions.payload,
      };
    },
    setIsInPayTab: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        isInPayTab: actions.payload,
      };
    },
    setTableThanhToan: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        tableThanhToan: actions.payload,
      };
    },
  },
});

export const {
  setId,
  setIdSecond,
  setDataPay,
  setMaBenhNhan,
  setCallApi,
  setDataRefunds,
  setOptionModal,
  setValueInput,
  setIdXetNghiem,
  setIdKQXN,
  setTotalMoney,
  setIdPrintXN,
  setNguoiDuyetXN,
  setListIdCommon,
  setValueMG,
  setTGChiDinh,
  setTGLayMau,
  setTypePhieu,
  setIsInPayTab,
  setTableThanhToan,
} = reduxCommonSlice.actions;
export default reduxCommonSlice.reducer;
